import { useModal } from '@ebay/nice-modal-react';
import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Plus } from 'assets/icons/Plus.svg';
import CreateWorkspaceModal from 'modules/CreateWorkspaceModal/CreateWorkspaceModal';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import WorkspacesList from 'modules/Workspaces/WorkspacesDropdown/WorkspacesList';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import { getHierarchyDisplayRootWorkspaceId } from './utils';

const WorkspaceHierarchySection = () => {
  const { t } = useTranslation();
  const { workspaceId: currentWorkspaceId, workspacesState, workspacePermissions } = useWorkspacesContext();
  const createWorkspaceModal = useModal(CreateWorkspaceModal);

  const hierarchyRootWorkspaceId = getHierarchyDisplayRootWorkspaceId(currentWorkspaceId, workspacesState.workspaces);
  const listWorkspaceIds = hierarchyRootWorkspaceId ? [hierarchyRootWorkspaceId] : [];
  const canCreateSubWorkspaces =
    workspacesState.rootWorkspaces.some(
      ({ workspaceId, isSubWorkspace }) => workspaceId === currentWorkspaceId && !isSubWorkspace
    ) && workspacePermissions.createSubWorkspace;

  const handleCreateSubWorkspace = () => createWorkspaceModal.show({ parentWorkspaceId: currentWorkspaceId });

  return (
    <SettingsCard>
      <div className="w-full h-full p-4 space-y-4">
        <div className="space-y-1">
          <p className="text-size-sm font-medium text-black">{t('workspaces.workspace_hierarchy')}</p>
          <p className="text-size-sm text-gray-80">{t('workspaces.workspace_hierarchy_desc')}</p>
        </div>
        <div className="w-auto">
          <WorkspacesList workspaces={listWorkspaceIds} initiallyExpandedDepth={1} hasMemberCount selectedId={null} />
        </div>
        {canCreateSubWorkspaces && (
          <Button
            variant="primary"
            size="sm"
            iconRight={{ icon: Plus, className: 'stroke-current w-5 h-5 stroke-1.5' }}
            onClick={handleCreateSubWorkspace}
          >
            {t('workspaces.create_sub_workspace')}
          </Button>
        )}
      </div>
    </SettingsCard>
  );
};

export default WorkspaceHierarchySection;
